module.exports = __webpack_public_path__ + "img/114.4cd40893.png";